import styled, { StyledComponent } from "styled-components";

const MainWrapper: StyledComponent<"div", any, {}, never> = styled.div`
  padding: 0;
  box-sizing: border-box;
  text-rendering: optimizeLegibility;
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  font-weight: 100;
  font-size:13px;
  line-height: 20px;
  color: #777;
  max-width: 400px;
  width: 100%;
  position: relative;
`;

const Form: StyledComponent<"form", any, {}, never> = styled.form`
  padding: 25px;
  max-width: 400px;
`;

const Title: StyledComponent<"h3", any, {}, never> = styled.h2`
  /* display: block; */
  font-weight: 300;
  margin: 0;
`;

const SubTitle: StyledComponent<"h4", any, {}, never> = styled.h4`
  margin: 0;
  display: block;
  font-weight: 400;
  margin-bottom: 10px;
`;

const TextArea: StyledComponent<"textarea", any, {}, never> = styled.textarea`
  height: 100px;
  max-width: 100%;
  resize: none;
  width: 100%;
  border: 1px solid #ccc;
  background: #fff;
  margin: 0 0 5px;
  padding: 10px;
  &:hover {
    transition: border-color 0.3s ease-in-out;
    border: 1px solid #aaa;
  }
  &:focus {
    outline: 0;
    border: 1px solid #aaa;
  }
`;

const Error = styled.div`
  color: #ff0000;
`;


export { MainWrapper, TextArea, Form, Title, SubTitle, Error };
